module.exports = __webpack_public_path__ + "static/img/kpa.246211b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/kpa.png
// module id = YlJ0
// module chunks = 0